module.exports = __webpack_public_path__ + "static/media/1.9168e6b7.jpg";